export default function ConfigIcon16() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_604_6222)">
        <path
          d="M7.33331 6.84671L4.66665 2.22671M7.33331 9.15337L4.66665 13.7734M7.99998 14.6667V13.3334M7.99998 13.3334C10.9455 13.3334 13.3333 10.9456 13.3333 8.00004C13.3333 5.05452 10.9455 2.66671 7.99998 2.66671M7.99998 13.3334C5.05446 13.3334 2.66665 10.9456 2.66665 8.00004M7.99998 1.33337V2.66671M7.99998 2.66671C5.05446 2.66671 2.66665 5.05452 2.66665 8.00004M9.33331 8.00004H14.6666M9.33331 8.00004C9.33331 8.73642 8.73636 9.33337 7.99998 9.33337C7.2636 9.33337 6.66665 8.73642 6.66665 8.00004C6.66665 7.26366 7.2636 6.66671 7.99998 6.66671C8.73636 6.66671 9.33331 7.26366 9.33331 8.00004ZM11.3333 13.7734L10.6666 12.62M11.3333 2.22671L10.6666 3.38004M1.33331 8.00004H2.66665M13.7733 11.3334L12.62 10.6667M13.7733 4.66671L12.62 5.33337M2.22665 11.3334L3.37998 10.6667M2.22665 4.66671L3.37998 5.33337"
          stroke="#A1A1AA"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_604_6222">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
